// Geometry constants — kept identical to PointTableV2/WindBarb.js so both
// renderers produce visually-identical glyphs.
const SHAFT_LEFT = -10;
const SHAFT_RIGHT = 10;
const SHAFT_Y = -2.5;
const TAIL_TICK = 5;
const FEATURE_HEIGHT = 5;
const PENNANT_HALF_BASE = 2.5; // 5-unit-wide pennant
const PENNANT_GAP = 1;         // gap after a pennant before the next feature
const FEATURE_SPACING = 3;     // gap between full/half barbs
const FEATURE_START_OFFSET = 3; // first feather sits 3 units inside the tail tick

const PENNANT_KT = 50;
const FULL_KT = 10;
const HALF_KT = 5;

// barbRotation: Skysight rotates barbs by atan2(-v, u) in degrees (bundle line 1335).
export function barbRotation(u, v) {
    return (Math.atan2(-v, u) * 180) / Math.PI;
}

// barbPath: build a meteorological barb glyph SVG path string for `speedKt`.
// Geometry is identical to the `buildBarbPath` inside PointTableV2/WindBarb.js.
// `centered` is accepted for API compatibility with the Skysight bundle
// La(speed, { centered: true }) call convention; the glyph is already centred on
// the shaft midpoint.
export function barbPath(speedKt, { centered = true } = {}) {
    const parts = [];
    parts.push(`M${SHAFT_LEFT},${SHAFT_Y}L${SHAFT_RIGHT},${SHAFT_Y}`);
    parts.push(`M${SHAFT_LEFT},${SHAFT_Y}L${SHAFT_LEFT},${SHAFT_Y + TAIL_TICK}`);

    let remaining = Math.round(speedKt / 5) * 5;
    const pennants = Math.floor(remaining / PENNANT_KT); remaining -= pennants * PENNANT_KT;
    const fulls = Math.floor(remaining / FULL_KT); remaining -= fulls * FULL_KT;
    const halves = Math.floor(remaining / HALF_KT);

    // Features extend from the tail end. Pennants are filled triangles (closed
    // with Z). Full and half barbs are perpendicular lines from the shaft.
    let cursor = pennants > 0 ? SHAFT_LEFT : SHAFT_LEFT + FEATURE_START_OFFSET;
    for (let i = 0; i < pennants; i++) {
        const base = cursor;
        const tip = cursor + 2 * PENNANT_HALF_BASE;
        parts.push(`M${base},${SHAFT_Y}L${base + PENNANT_HALF_BASE},${SHAFT_Y + FEATURE_HEIGHT}L${tip},${SHAFT_Y}Z`);
        cursor = tip + PENNANT_GAP;
    }
    for (let i = 0; i < fulls; i++) {
        parts.push(`M${cursor},${SHAFT_Y}L${cursor},${SHAFT_Y + FEATURE_HEIGHT}`);
        cursor += FEATURE_SPACING;
    }
    for (let i = 0; i < halves; i++) {
        parts.push(`M${cursor},${SHAFT_Y}L${cursor},${SHAFT_Y + FEATURE_HEIGHT / 2}`);
        cursor += FEATURE_SPACING;
    }

    return parts.join('');
}
